import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { initSessionDataFromBrowser } from "./initializeSessionData";

export type SessionData = {
    accessCode: string | null;
    userId: string | null;
    sessionId: string | null;
    postSurveyTimeInSeconds: number;
};

const initialState = initSessionDataFromBrowser();

const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        hydrateSessionData: (_, action: PayloadAction<SessionData>) => {
            return action.payload;
        },
        startNewSession: (state) => {
            state.sessionId = uuidv4();
        },
        setAccessCode: (state, action: PayloadAction<string | null>) => {
            state.accessCode = action.payload;
        },
        setUserId: (state, action: PayloadAction<string | null>) => {
            state.userId = action.payload;
        },
        setPostSurveyTime: (state, action: PayloadAction<number>) => {
            state.postSurveyTimeInSeconds = action.payload;
        },
    },
});

export const { hydrateSessionData, startNewSession, setAccessCode, setUserId, setPostSurveyTime } =
    sessionSlice.actions;

export default sessionSlice.reducer;
